import React from 'react';
import * as Icons from 'react-feather';

/**
 * FeatherIcon - A React-compatible wrapper for Feather icons
 * This prevents DOM manipulation conflicts when using feather.replace()
 * 
 * Usage: <FeatherIcon name="activity" size={16} className="me-2" />
 */
// Special casing for icons that react-feather exports with unconventional names
const SPECIAL_ICON_NAMES = {
    'github': 'GitHub',
    'linkedin': 'LinkedIn',
    'youtube': 'YouTube',
    'gitlab': 'GitLab',
    'codepen': 'CodePen',
    'airplay': 'Airplay'
};

const FeatherIcon = ({ name, size = 24, className = '', style = {}, ...props }) => {
    if (!name) {
        console.warn('FeatherIcon: name prop is undefined or empty');
        return null;
    }
    // Check for special cases first
    let iconName = SPECIAL_ICON_NAMES[name.toLowerCase()];

    // If not a special case, convert kebab-case to PascalCase
    if (!iconName) {
        iconName = name
            .split('-')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join('');
    }

    const IconComponent = Icons[iconName];

    if (!IconComponent) {
        console.warn(`FeatherIcon: Icon "${name}" not found`);
        return null;
    }

    return (
        <IconComponent
            size={size}
            className={className}
            style={style}
            {...props}
        />
    );
};

export default FeatherIcon;
